import type { FC } from "react"
import React, { useEffect, useState } from "react"
import { useTheme } from "@mui/material/styles"
import {
  Box,
  IconButton,
  Button,
  Typography,
  Stack,
} from "../../../components/mui.components"
import { useAppDispatch } from "@/core/app/hooks"

import CloseSvg from "../../assets/modeltools/RedXMark.svg"
import InPng from "../../assets/modelcheck/toothsurface/surface_in.png"
import OutPng from "../../assets/modelcheck/toothsurface/surface_out.png"
import { meshdeformModel } from "@/gluelayer/core/modules/modulemesh/modulemeshdeform"

interface Type {
  ClickPaint?: (On: boolean) => void
  ClickInOut?: (On: boolean) => void
  ClickSmooth?: (On: boolean) => void
  ClickCutFill?: (On: boolean) => void
  ClickUndo?: () => void
  ClickReset?: () => void
  ClickClose?: (e) => void
  DoShowClose?: boolean
}

const ToothSurfaceTools: FC<Type> = ({
  ClickPaint,
  ClickInOut,
  ClickSmooth,
  ClickCutFill,
  ClickUndo,
  ClickReset,
  ClickClose,
  DoShowClose,
}) => {
  const dispatch = useAppDispatch()
  const theme = useTheme()

  const [selectedItem, setSelectedItem] = useState<string | null>("")
  const [lastSelectedItem, setLastSelectedItem] = useState<string | null>("")

  const buttonNames = ["Smooth", "Paint", "In/Out", "Cut&Fill", "Undo", "Reset"]

  const [inOutButtonPos, setInOutButtonPos] = useState<{
    x: number
    y: number
  }>({ x: 0, y: 0 })
  const [inOutButtonVisible, setInOutButtonVisible] = useState<boolean>(false)

  React.useEffect(() => {
    switch (lastSelectedItem) {
      case buttonNames[0]:
        if (ClickSmooth) ClickSmooth(false)
        break
      case buttonNames[1]:
        if (ClickPaint) ClickPaint(false)
        break
      case buttonNames[2]:
        if (ClickPaint) ClickPaint(false)
        break
      case buttonNames[3]:
        if (ClickPaint) ClickPaint(false)
        break

      default:
    }

    switch (selectedItem) {
      case buttonNames[0]:
        if (ClickSmooth) ClickSmooth(true)
        break
      case buttonNames[1]:
        if (ClickPaint) ClickPaint(true)
        break
      case buttonNames[2]:
        if (ClickPaint) ClickPaint(true)
        break
      case buttonNames[3]:
        if (ClickPaint) ClickPaint(true)
        break
      default:
    }

    setLastSelectedItem(selectedItem)
  }, [selectedItem])

  useEffect(() => {
    if (selectedItem === "In/Out" || selectedItem === "Cut&Fill") {
      meshdeformModel.Set2DButtonsVisiblityJsCallBack((isShow: boolean) => {
        console.log("Set2DButtonsVisiblityJsCallBack isShow:", isShow)
        setInOutButtonVisible(isShow)
      })
      meshdeformModel.SetUpdate2DButtonsPosJsCallBack(
        (x: number, y: number) => {
          console.log("SetUpdate2DButtonsPosJsCallBack x:", x, " y:", y)
          setInOutButtonPos({ x: x, y: y })
        },
      )
    }
  }, [selectedItem])

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          position: "absolute",
          top: "250px",
          right: "1%",
          width: "130px",
          height: "500px",
          borderRadius: 2,
          flexDirection: "column",

          //bgcolor: theme.transBkColor.light
        }}
      >
        <Box
          sx={{
            display: "flex",
            right: "2%",
            width: "250px",
            height: "70px",
            borderRadius: 2,
            flexDirection: "row",
            alignItems: "center",
            //bgcolor: theme.transBkColor.light
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              width: "100%",
              height: "70px",
              borderRadius: 2,
              flexDirection: "column",
              marginRight: "20px",

              //bgcolor: theme.transBkColor.light
            }}
          >
            <Typography variant="h5" color="#FFFFFF">
              Check Model
            </Typography>
            <Typography variant="h5" color="#FFFFFF">
              Surface
            </Typography>
          </Box>

          {DoShowClose && (
            <Box
              sx={{
                display: "flex",
                alignItems: "column",
                width: "35px",
                height: "45px",
              }}
            >
              <IconButton
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "35px",
                  height: "35px",
                  borderRadius: 100,
                  backgroundColor: "#FF632B",
                  "&:hover": { background: "#FF632B" },
                }}
                onClick={ClickClose}
              >
                <img
                  src={CloseSvg}
                  style={{ height: "18px", width: "18px" }}
                ></img>
              </IconButton>
            </Box>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginTop: "15px",
            width: "65px",
            height: "auto",
            // borderRadius: 2,
            flexDirection: "column",
            marginRight: "5px",
            // gap: "1px",
            // paddingTop: "15px",
            // paddingBottom: "15px",
            // backgroundColor: theme.transBkColor.light,
          }}
        >
          <Button
            sx={{
              height: "65px",
              width: "65px",
              textTransform: "none",
              flexWrap: "wrap",
              border: "none",
              padding: "0px 0px",
              borderRadius: "0px",
              // background: "#f9f9f9",
              // "&:hover": {
              //   background: "#f9f9f9",
              // },
              borderBottom: "1px solid",
              borderColor: "rgba(59 / 255, 66 / 255,  71 / 255 )",
              // backgroundColor:
              //   selectedItem === buttonNames[0]
              //     ? theme.transBkColor.light
              //     : "rgba(0, 0, 0, 0.0)",
              background:
                selectedItem === buttonNames[0] ? "#00ADEF" : "#f9f9f9",
              "&:hover": {
                background:
                  selectedItem === buttonNames[0] ? "#00ADEF" : "#f9f9f9",
              },
            }}
            onClick={(e) => {
              if (buttonNames[0] != lastSelectedItem) {
                setSelectedItem(buttonNames[0])
              } else {
                setSelectedItem("")
              }
            }}
          >
            <Typography
              fontSize="14px"
              fontWeight="600"
              fontFamily="Roboto"
              fontStyle="normal"
              color="#444444"
              letterSpacing="0.1px"
            >
              {buttonNames[0]}
            </Typography>
          </Button>

          <Button
            sx={{
              height: "65px",
              width: "65px",
              textTransform: "none",
              flexWrap: "wrap",
              border: "none",
              padding: "0px 0px",
              borderRadius: "0px",
              background:
                selectedItem === buttonNames[2] ? "#00ADEF" : "#f9f9f9",
              "&:hover": {
                background:
                  selectedItem === buttonNames[2] ? "#00ADEF" : "#f9f9f9",
              },
              borderBottom: "1px solid",
              borderColor: "rgba(59 / 255, 66 / 255,  71 / 255 )",
              // backgroundColor:
              //   selectedItem === buttonNames[2]
              //     ? theme.transBkColor.light
              //     : "rgba(0, 0, 0, 0.0)",
            }}
            onClick={(e) => {
              if (buttonNames[2] != lastSelectedItem) {
                setSelectedItem(buttonNames[2])
              } else {
                setSelectedItem("")
              }
            }}
          >
            <Typography
              fontSize="14px"
              fontWeight="600"
              fontFamily="Roboto"
              fontStyle="normal"
              color={selectedItem === buttonNames[2] ? "#fff" : "#444444"}
              letterSpacing="0.1px"
            >
              {buttonNames[2]}
            </Typography>
          </Button>

          <Button
            sx={{
              height: "65px",
              width: "65px",
              textTransform: "none",
              flexWrap: "wrap",
              border: "none",
              padding: "0px 0px",
              borderRadius: "0px",
              background:
                selectedItem === buttonNames[3] ? "#00ADEF" : "#f9f9f9",
              "&:hover": {
                background:
                  selectedItem === buttonNames[3] ? "#00ADEF" : "#f9f9f9",
              },
              borderBottom: "1px solid",
              borderColor: "rgba(59 / 255, 66 / 255,  71 / 255 )",
              // backgroundColor:
              //   selectedItem === buttonNames[3]
              //     ? theme.transBkColor.light
              //     : "rgba(0, 0, 0, 0.0)",
            }}
            onClick={(e) => {
              if (buttonNames[3] != lastSelectedItem) {
                setSelectedItem(buttonNames[3])
              } else {
                setSelectedItem("")
              }
            }}
          >
            <Typography
              fontSize="14px"
              fontWeight="600"
              fontFamily="Roboto"
              fontStyle="normal"
              color={selectedItem === buttonNames[3] ? "#fff" : "#444444"}
              letterSpacing="0.1px"
            >
              {buttonNames[3]}
            </Typography>
          </Button>

          <Button
            sx={{
              height: "65px",
              width: "65px",
              textTransform: "none",
              flexWrap: "wrap",
              padding: "0px 0px",
              border: "none",
              borderRadius: "0px",
              background: "#f9f9f9",
              "&:hover": {
                background: "#f9f9f9",
              },
              borderBottom: "1px solid",
              borderColor: "rgba(59 / 255, 66 / 255,  71 / 255 )",
              // backgroundColor: "rgba(0, 0, 0, 0.0)",
            }}
            onClick={(e) => {
              if (ClickUndo) ClickUndo()
            }}
          >
            <Typography
              fontSize="14px"
              fontWeight="600"
              fontFamily="Roboto"
              fontStyle="normal"
              color="#444444"
              letterSpacing="0.1px"
            >
              {buttonNames[4]}
            </Typography>
          </Button>

          <Button
            sx={{
              height: "65px",
              width: "65px",
              textTransform: "none",
              padding: "0px 0px",
              flexWrap: "wrap",
              border: "none",
              borderRadius: "0px",
              background: "#f9f9f9",
              "&:hover": {
                background: "#f9f9f9",
              },
              // backgroundColor: "rgba(0, 0, 0, 0.0)",
            }}
            onClick={(e) => {
              if (ClickReset) ClickReset()
              setSelectedItem("")
            }}
          >
            <Typography
              fontSize="14px"
              fontWeight="600"
              fontFamily="Roboto"
              fontStyle="normal"
              color="#444444"
              letterSpacing="0.1px"
            >
              {buttonNames[5]}
            </Typography>
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          visibility: inOutButtonVisible ? "visible" : "hidden",
          position: "absolute",
          bottom: inOutButtonPos.y,
          left: inOutButtonPos.x,
          display: "flex",
          alignItems: "center",
          gap: 4,
          zIndex: 999,
          translate: "-50%",
        }}
      >
        {lastSelectedItem === "Cut&Fill" && (
          <Button
            onClick={() => {
              meshdeformModel.FillTooth()
            }}
            sx={{
              width: 70,
              height: 70,
              borderRadius: "12px",
              backgroundColor: "rgba(230, 230, 230, 1)",
              color: "#000",
              boxShadow: "0 4px 8px rgba(0,0,0,0.20)",
              fontSize: 20,
              fontWeight: 500,
              lineHeight: 1.2,
              textTransform: "none",

              "&:hover": {
                backgroundColor: "rgba(180, 180, 180, 1)",
              },
            }}
          >
            Cut
            <br />
            &Fill
          </Button>
        )}

        {lastSelectedItem === "In/Out" && (
          <Stack spacing={1}>
            <Button
              onClick={() => {
                meshdeformModel.StartDeform(true)
              }}
              sx={{
                width: 70,
                height: 30,
                borderRadius: "8px",
                // backgroundColor: "#ffffff",
                color: "#000",
                boxShadow: "0 3px 6px rgba(0,0,0,0.20)",
                textTransform: "none",
                fontSize: 18,
                padding: 0,
                minWidth: 0,
                overflow: "hidden",
                "&:hover img": {
                  filter: "brightness(0.8)",
                },
              }}
            >
              <img
                src={OutPng}
                alt="up"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </Button>

            <Button
              onClick={() => {
                meshdeformModel.StartDeform(false)
              }}
              sx={{
                width: 70,
                height: 30,
                borderRadius: "8px",
                // backgroundColor: "#ffffff",
                color: "#000",
                boxShadow: "0 3px 6px rgba(0,0,0,0.20)",
                textTransform: "none",
                fontSize: 18,
                padding: 0,
                minWidth: 0,
                overflow: "hidden",
                "&:hover img": {
                  filter: "brightness(0.8)",
                },
              }}
            >
              <img
                src={InPng}
                alt="up"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </Button>
          </Stack>
        )}
      </Box>
    </>
  )
}
export default ToothSurfaceTools
